import { TriangleArrowLeftIcon } from "@/shared/icons/TriangleArrowLeftIcon";

export function BankATMBackButton({ onClick }: { onClick: () => void }) {
  return (
    <button
      type="button"
      onMouseDown={onClick}
      className="absolute top-0 left-0 mb-6 inline-flex items-center gap-2 bg-white text-dark-800 uppercase text-11 font-bold rounded-xl h-8 px-3 hover:text-gray-700 transition-all duration-200 shadow-sbank-control hover:shadow-sbank-control-hover"
    >
      <TriangleArrowLeftIcon className="size-2.5" /> В меню
    </button>
  );
}
